"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Calendar = exports.AppStore = exports.Analytics = exports.MoodBad = exports.DoorLocked = exports.WarningTriangle = exports.Attention = exports.WaveHand = exports.WarningCircle = exports.Warning = exports.WalletOutlined = exports.StatementAdded = exports.StatementAdd = exports.Statement = exports.SpeechOutlined = exports.Speech = exports.ShoppingOutlined = exports.Shopping = exports.Secure = exports.Search = exports.ScheduledPaymentDate = exports.Scheduled = exports.ScheduleAdded = exports.ScanOutlined = exports.SafelySpend = exports.Rocket = exports.Reuse = exports.ReturnLeft = exports.RecentClock = exports.ProfileOutlined = exports.PriceTag = exports.Pencil = exports.Payment = exports.PageOutlined = exports.Password = exports.Notifications = exports.MoreVertical = exports.MoreHorizontal = exports.Menu = exports.Lock = exports.Location = exports.List = exports.Link = exports.Info = exports.Image = exports.Paypal = exports.Facebook = exports.Home = exports.Help = exports.EyeSlashHollow = exports.EyeSlash = exports.EyeOpenHollow = exports.EyeOpen = exports.Exit = exports.EmptyProfile = exports.Email = exports.DoneOutlined = exports.DoneCircle = exports.Done = exports.DollarOutlined = exports.Dollar = exports.DocumentOutlined = exports.DeleteCircle = exports.Delete = exports.CreditCard = exports.Cart = exports.CalendarSubscriptions = exports.Camera = exports.BellOutlined = exports.Bank = exports.Backspace = exports.Atm = exports.ArrowUp = exports.ArrowRight = exports.ArrowMoveUp = exports.ArrowMoveRight = exports.ArrowMoveDown = exports.ArrowMoveBack = exports.ArrowLeft = exports.ArrowDown = exports.AddCircle = exports.Add = exports.Activity = exports.ZipTradePlus = exports.ZipTrade = exports.ZipMoney = exports.ZipPay = exports.WarningColor = exports.ZipLogoMono = exports.ZipPayLogo = exports.ZipLogo = exports.Visa = exports.Tick = exports.Spark = exports.Mastercard = exports.WarningDialog = exports.News = exports.DoneCircleGrey = exports.ApplePay = exports.App = void 0;
exports.Close = exports.Copy = exports.Sad = exports.WarningCircleFearless = exports.UserCircle = exports.User = exports.TrendGraph = exports.ShoppingCart = exports.Settings = exports.Plus = exports.FearlessHome = exports.EyeStrike = exports.Eye = exports.CurrencyDollarSimple = exports.Calculator = exports.Application = exports.ZipFearlessLogoMark = exports.ZipFearlessLogo = exports.WarningUnsuccessful = exports.WarningExpired = exports.Wave = exports.Success = exports.MoneyWithWings = exports.Money = exports.MegaPhone = exports.MagnifyingGlass = exports.HammerAndWrench = exports.AlarmClock = exports.NothingToPay = exports.Hooray = exports.Edit = exports.Card = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _presets = require("@zip/theme/dist/presets");

var svg = _interopRequireWildcard(require("./svg"));

var _Icon = _interopRequireDefault(require("./Icon.styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var withBase = function withBase(BaseIcon) {
  var Icon = function Icon(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === void 0 ? 32 : _ref$size,
        title = _ref.title,
        props = _objectWithoutProperties(_ref, ["size", "title"]);

    return (0, _jsxRuntime.jsx)(BaseIcon, _objectSpread({
      css: [_Icon["default"], {
        width: "".concat(size, "px")
      }],
      title: title
    }, props));
  };

  return Icon;
};

var withTheme = function withTheme(BaseIcon) {
  var Icon = function Icon(_ref2) {
    var _ref2$fill = _ref2.fill,
        fill = _ref2$fill === void 0 ? _presets.legacy.colors.primary.main : _ref2$fill,
        _ref2$size = _ref2.size,
        size = _ref2$size === void 0 ? 32 : _ref2$size,
        title = _ref2.title,
        variant = _ref2.variant,
        shape = _ref2.shape,
        theme = _ref2.theme,
        props = _objectWithoutProperties(_ref2, ["fill", "size", "title", "variant", "shape", "theme"]);

    return (0, _jsxRuntime.jsx)(BaseIcon, _objectSpread({
      css: [_Icon["default"], {
        width: "".concat(size, "px")
      }],
      fill: fill,
      theme: theme,
      variant: variant,
      shape: shape,
      title: title
    }, props));
  };

  return Icon;
};

var App = withBase(svg.App);
exports.App = App;
var ApplePay = withBase(svg.ApplePay);
exports.ApplePay = ApplePay;
var DoneCircleGrey = withBase(svg.DoneCircleGrey);
exports.DoneCircleGrey = DoneCircleGrey;
var News = withTheme(svg.News);
exports.News = News;
var WarningDialog = withTheme(svg.WarningDialog);
exports.WarningDialog = WarningDialog;
var Mastercard = withBase(svg.Mastercard);
exports.Mastercard = Mastercard;
var Spark = withTheme(svg.Spark);
exports.Spark = Spark;
var Tick = withBase(svg.Tick);
exports.Tick = Tick;
var Visa = withBase(svg.Visa);
exports.Visa = Visa;
var ZipLogo = withBase(svg.ZipLogo);
exports.ZipLogo = ZipLogo;
var ZipPayLogo = withBase(svg.ZipPayLogo);
exports.ZipPayLogo = ZipPayLogo;
var ZipLogoMono = withTheme(svg.ZipLogoMono);
exports.ZipLogoMono = ZipLogoMono;
var WarningColor = withBase(svg.WarningColor);
exports.WarningColor = WarningColor;
var ZipPay = withBase(svg.ZipPay);
exports.ZipPay = ZipPay;
var ZipMoney = withBase(svg.ZipMoney);
exports.ZipMoney = ZipMoney;
var ZipTrade = withBase(svg.ZipTrade);
exports.ZipTrade = ZipTrade;
var ZipTradePlus = withBase(svg.ZipTradePlus);
exports.ZipTradePlus = ZipTradePlus;
var Activity = withTheme(svg.Activity);
exports.Activity = Activity;
var Add = withTheme(svg.Add);
exports.Add = Add;
var AddCircle = withTheme(svg.AddCircle);
exports.AddCircle = AddCircle;
var ArrowDown = withTheme(svg.ArrowDown);
exports.ArrowDown = ArrowDown;
var ArrowLeft = withTheme(svg.ArrowLeft);
exports.ArrowLeft = ArrowLeft;
var ArrowMoveBack = withTheme(svg.ArrowMoveBack);
exports.ArrowMoveBack = ArrowMoveBack;
var ArrowMoveDown = withTheme(svg.ArrowMoveDown);
exports.ArrowMoveDown = ArrowMoveDown;
var ArrowMoveRight = withTheme(svg.ArrowMoveRight);
exports.ArrowMoveRight = ArrowMoveRight;
var ArrowMoveUp = withTheme(svg.ArrowMoveUp);
exports.ArrowMoveUp = ArrowMoveUp;
var ArrowRight = withTheme(svg.ArrowRight);
exports.ArrowRight = ArrowRight;
var ArrowUp = withTheme(svg.ArrowUp);
exports.ArrowUp = ArrowUp;
var Atm = withTheme(svg.Atm);
exports.Atm = Atm;
var Backspace = withTheme(svg.Backspace);
exports.Backspace = Backspace;
var Bank = withTheme(svg.Bank);
exports.Bank = Bank;
var BellOutlined = withTheme(svg.BellOutlined);
exports.BellOutlined = BellOutlined;
var Camera = withTheme(svg.Camera);
exports.Camera = Camera;
var CalendarSubscriptions = withTheme(svg.CalendarSubscriptions);
exports.CalendarSubscriptions = CalendarSubscriptions;
var Cart = withTheme(svg.Cart);
exports.Cart = Cart;
var CreditCard = withTheme(svg.CreditCard);
exports.CreditCard = CreditCard;
var Delete = withTheme(svg.Delete);
exports.Delete = Delete;
var DeleteCircle = withTheme(svg.DeleteCircle);
exports.DeleteCircle = DeleteCircle;
var DocumentOutlined = withTheme(svg.DocumentOutlined);
exports.DocumentOutlined = DocumentOutlined;
var Dollar = withTheme(svg.Dollar);
exports.Dollar = Dollar;
var DollarOutlined = withTheme(svg.DollarOutlined);
exports.DollarOutlined = DollarOutlined;
var Done = withTheme(svg.Done);
exports.Done = Done;
var DoneCircle = withTheme(svg.DoneCircle);
exports.DoneCircle = DoneCircle;
var DoneOutlined = withTheme(svg.DoneOutlined);
exports.DoneOutlined = DoneOutlined;
var Email = withTheme(svg.Email);
exports.Email = Email;
var EmptyProfile = withTheme(svg.EmptyProfile);
exports.EmptyProfile = EmptyProfile;
var Exit = withTheme(svg.Exit);
exports.Exit = Exit;
var EyeOpen = withTheme(svg.EyeOpen);
exports.EyeOpen = EyeOpen;
var EyeOpenHollow = withTheme(svg.EyeOpenHollow);
exports.EyeOpenHollow = EyeOpenHollow;
var EyeSlash = withTheme(svg.EyeSlash);
exports.EyeSlash = EyeSlash;
var EyeSlashHollow = withTheme(svg.EyeSlashHollow);
exports.EyeSlashHollow = EyeSlashHollow;
var Help = withTheme(svg.Help);
exports.Help = Help;
var Home = withTheme(svg.Home);
exports.Home = Home;
var Facebook = withTheme(svg.Facebook);
exports.Facebook = Facebook;
var Paypal = withTheme(svg.Paypal);
exports.Paypal = Paypal;
var Image = withTheme(svg.Image);
exports.Image = Image;
var Info = withTheme(svg.Info);
exports.Info = Info;
var Link = withTheme(svg.Link);
exports.Link = Link;
var List = withTheme(svg.List);
exports.List = List;
var Location = withTheme(svg.Location);
exports.Location = Location;
var Lock = withTheme(svg.Lock);
exports.Lock = Lock;
var Menu = withTheme(svg.Menu);
exports.Menu = Menu;
var MoreHorizontal = withTheme(svg.MoreHorizontal);
exports.MoreHorizontal = MoreHorizontal;
var MoreVertical = withTheme(svg.MoreVertical);
exports.MoreVertical = MoreVertical;
var Notifications = withTheme(svg.Notifications);
exports.Notifications = Notifications;
var Password = withTheme(svg.Password);
exports.Password = Password;
var PageOutlined = withTheme(svg.PageOutlined);
exports.PageOutlined = PageOutlined;
var Payment = withTheme(svg.Payment);
exports.Payment = Payment;
var Pencil = withTheme(svg.Pencil);
exports.Pencil = Pencil;
var PriceTag = withTheme(svg.PriceTag);
exports.PriceTag = PriceTag;
var ProfileOutlined = withTheme(svg.ProfileOutlined);
exports.ProfileOutlined = ProfileOutlined;
var RecentClock = withTheme(svg.RecentClock);
exports.RecentClock = RecentClock;
var ReturnLeft = withTheme(svg.ReturnLeft);
exports.ReturnLeft = ReturnLeft;
var Reuse = withTheme(svg.Reuse);
exports.Reuse = Reuse;
var Rocket = withTheme(svg.Rocket);
exports.Rocket = Rocket;
var SafelySpend = withTheme(svg.SafelySpend);
exports.SafelySpend = SafelySpend;
var ScanOutlined = withTheme(svg.ScanOutlined);
exports.ScanOutlined = ScanOutlined;
var ScheduleAdded = withTheme(svg.ScheduleAdded);
exports.ScheduleAdded = ScheduleAdded;
var Scheduled = withTheme(svg.Scheduled);
exports.Scheduled = Scheduled;
var ScheduledPaymentDate = withTheme(svg.ScheduledPaymentDate);
exports.ScheduledPaymentDate = ScheduledPaymentDate;
var Search = withTheme(svg.Search);
exports.Search = Search;
var Secure = withTheme(svg.Secure);
exports.Secure = Secure;
var Shopping = withTheme(svg.Shopping);
exports.Shopping = Shopping;
var ShoppingOutlined = withTheme(svg.ShoppingOutlined);
exports.ShoppingOutlined = ShoppingOutlined;
var Speech = withTheme(svg.Speech);
exports.Speech = Speech;
var SpeechOutlined = withTheme(svg.SpeechOutlined);
exports.SpeechOutlined = SpeechOutlined;
var Statement = withTheme(svg.Statement);
exports.Statement = Statement;
var StatementAdd = withTheme(svg.StatementAdd);
exports.StatementAdd = StatementAdd;
var StatementAdded = withTheme(svg.StatementAdded);
exports.StatementAdded = StatementAdded;
var WalletOutlined = withTheme(svg.WalletOutlined);
exports.WalletOutlined = WalletOutlined;
var Warning = withTheme(svg.Warning);
exports.Warning = Warning;
var WarningCircle = withTheme(svg.WarningCircle);
exports.WarningCircle = WarningCircle;
var WaveHand = withTheme(svg.WaveHand);
exports.WaveHand = WaveHand;
var Attention = withTheme(svg.Attention);
exports.Attention = Attention;
var WarningTriangle = withTheme(svg.WarningTriangle);
exports.WarningTriangle = WarningTriangle;
var DoorLocked = withTheme(svg.DoorLocked);
exports.DoorLocked = DoorLocked;
var MoodBad = withTheme(svg.MoodBad);
exports.MoodBad = MoodBad;
var Analytics = withBase(svg.Analytics);
exports.Analytics = Analytics;
var AppStore = withBase(svg.AppStore);
exports.AppStore = AppStore;
var Calendar = withBase(svg.Calendar);
exports.Calendar = Calendar;
var Card = withBase(svg.Card);
exports.Card = Card;
var Edit = withBase(svg.Edit);
exports.Edit = Edit;
var Hooray = withBase(svg.Hooray);
exports.Hooray = Hooray;
var NothingToPay = withBase(svg.NothingToPay);
exports.NothingToPay = NothingToPay;
var AlarmClock = withBase(svg.AlarmClock);
exports.AlarmClock = AlarmClock;
var HammerAndWrench = withBase(svg.HammerAndWrench);
exports.HammerAndWrench = HammerAndWrench;
var MagnifyingGlass = withBase(svg.MagnifyingGlass);
exports.MagnifyingGlass = MagnifyingGlass;
var MegaPhone = withBase(svg.MegaPhone);
exports.MegaPhone = MegaPhone;
var Money = withBase(svg.Money);
exports.Money = Money;
var MoneyWithWings = withBase(svg.MoneyWithWings);
exports.MoneyWithWings = MoneyWithWings;
var Success = withBase(svg.Success);
exports.Success = Success;
var Wave = withBase(svg.Wave);
exports.Wave = Wave;
var WarningExpired = withBase(svg.WarningExpired);
exports.WarningExpired = WarningExpired;
var WarningUnsuccessful = withBase(svg.WarningUnsuccessful);
exports.WarningUnsuccessful = WarningUnsuccessful;
var ZipFearlessLogo = withTheme(svg.ZipFearlessLogo);
exports.ZipFearlessLogo = ZipFearlessLogo;
var ZipFearlessLogoMark = withTheme(svg.ZipFearlessLogoMark);
exports.ZipFearlessLogoMark = ZipFearlessLogoMark;
var Application = withTheme(svg.Application);
exports.Application = Application;
var Calculator = withTheme(svg.Calculator);
exports.Calculator = Calculator;
var CurrencyDollarSimple = withTheme(svg.CurrencyDollarSimple);
exports.CurrencyDollarSimple = CurrencyDollarSimple;
var Eye = withTheme(svg.Eye);
exports.Eye = Eye;
var EyeStrike = withTheme(svg.EyeStrike);
exports.EyeStrike = EyeStrike;
var FearlessHome = withTheme(svg.FearlessHome);
exports.FearlessHome = FearlessHome;
var Plus = withTheme(svg.Plus);
exports.Plus = Plus;
var Settings = withTheme(svg.Settings);
exports.Settings = Settings;
var ShoppingCart = withTheme(svg.ShoppingCart);
exports.ShoppingCart = ShoppingCart;
var TrendGraph = withTheme(svg.TrendGraph);
exports.TrendGraph = TrendGraph;
var User = withTheme(svg.User);
exports.User = User;
var UserCircle = withTheme(svg.UserCircle);
exports.UserCircle = UserCircle;
var WarningCircleFearless = withTheme(svg.WarningCircleFearless);
exports.WarningCircleFearless = WarningCircleFearless;
var Sad = withTheme(svg.Sad);
exports.Sad = Sad;
var Copy = withTheme(svg.Copy);
exports.Copy = Copy;
var Close = withTheme(svg.Close);
exports.Close = Close;